import { __export } from "./chunk-QK4PKNB3.mjs"; // src/utils/UploadImage.ts

var UploadImage_exports = {};

__export(UploadImage_exports, {
  checkUploadInfo: function checkUploadInfo() {
    return _checkUploadInfo;
  }
});

import _ from "lodash";

var _checkUploadInfo = function _checkUploadInfo(assets) {
  return _.every(assets, function (_ref) {
    var mediaType = _ref.mediaType,
        uploadInfo = _ref.uploadInfo,
        uri = _ref.uri,
        _processed = _ref._processed;
    var checkOk = false;

    if (mediaType === "video") {
      checkOk = uri ? _.isObject(uploadInfo) : true;
    } else {
      checkOk = uri ? _.isObject(uploadInfo) && _processed : true;
    }

    return checkOk;
  });
};

export { _checkUploadInfo as checkUploadInfo, UploadImage_exports };